import { SelfServiceObjectServicesResponseDto } from '@ekt-group/general-purpose-api-interfaces';
import { useQuery, queryOptions } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

type QueryParams = {
  objectIds: number[];
};

export const getObjectServices = async (params: QueryParams) => {
  const { data } = await httpService.get<SelfServiceObjectServicesResponseDto[]>('/self-service/objects/services', {
    params,
  });
  return data;
};

export const getObjectServicesQueryOptions = (params: QueryParams) => {
  return queryOptions({
    queryKey: ['object-services', params],
    queryFn: () => getObjectServices(params),
  });
};

type UseObjectServicesOptions = {
  params: QueryParams;
  queryConfig?: QueryConfig<typeof getObjectServicesQueryOptions>;
};

export const useGetObjectServices = ({ params, queryConfig }: UseObjectServicesOptions) => {
  return useQuery({
    ...getObjectServicesQueryOptions(params),
    ...queryConfig,
  });
};
